import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import testable from '@xingternal/malt-util/testable';
import { QA_MALT } from '@xingternal/malt-constants';

import Checkbox from './Checkbox';
import styles from './Checkbox.css';
import Label from '@xingternal/malt-label';

const TestableDiv = testable(QA_MALT, 'div');

const CheckboxGroup = ({
  label,
  children,
  className,
  orientation,
  testId,
  type = 'mobile',
}) => (
  <TestableDiv
    className={classnames(className, styles.checkboxGroup)}
    testId={testId}
  >
    <Label
      className={classnames(styles.groupLabel, {
        [styles.groupLabelMobile]: type === 'mobile',
      })}
    >
      {label}
    </Label>
    {React.Children.map(children, child => {
      if (child.type !== Checkbox) {
        throw new Error('<CheckboxGroup /> can only contain <Checkbox />');
      }

      return {
        ...child,
        props: {
          ...child.props,
          className: classnames(child.props.className, styles[orientation], {
            [styles.mobile]: type === 'mobile',
          }),
        },
      };
    })}
  </TestableDiv>
);

CheckboxGroup.defaultProps = {
  orientation: 'vertical',
};

CheckboxGroup.propTypes = {
  /** Pass custom class to CheckboxGroup div */
  className: PropTypes.string,
  /** The checkboxes belong here */
  children: PropTypes.node.isRequired,
  /** pass a custom orientation to the group, can be vertical or horizontal */
  orientation: PropTypes.oneOf(['vertical', 'horizontal']),
  /** choose a type for the checkbox group */
  type: PropTypes.oneOf(['normal', 'mobile']),
  /** Set the checkbox group label */
  label: PropTypes.string,
  /** define a testid for the checkbox group */
  testId: PropTypes.string,
};

CheckboxGroup.displayName = 'CheckboxGroup';

export default CheckboxGroup;
